module.exports = __webpack_public_path__ + "static/media/ankleBackRight.f28b45ef.png";